(function() {

    const colorTilesScript = document.querySelector("#json-colour-tiles").innerText;
    const jsonColourTiles = JSON.parse(colorTilesScript);
    const sortedColourTiles = jsonColourTiles.colour_tiles.sort((a, b) => a.order - b.order);
    const colourTilesWrapper = document.querySelector("[data-id='all-colours'] .preview-items-sec");
    renderColourTiles(colourTilesWrapper, sortedColourTiles);

    const colorGroupScript = document.querySelector("#json-colour-group").innerText;
    const jsonColourGroup = JSON.parse(colorGroupScript);
    const sortedColourGroups = jsonColourGroup.colour_groups.sort((a, b) => a.order - b.order);
    const colourGroupWrapper = document.querySelector("[data-id='colour-groups'] .grid-with-next-row-sec");
    renderColourGroups(colourGroupWrapper, sortedColourGroups);

    function renderColourGroups(wrapper, colourGroups) {
        wrapper.innerHTML = colourGroups.map((colourGroup, index) => {
            const backgrounds = colourGroup.backgrounds.map((colors)=> `<div class="colorGroup-color" style="background:${colors}"></div>`).join("");
            return `<div class="grid-item grid-colour__group" data-index="${index}" style="order:${index}">
                <button class="colorGroup">
                    ${backgrounds}
                    <div class="colorGroup-text" style="color: ${colourGroup.name_colour}">${colourGroup.name}<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
                            <path class="fill-color" d="m17.5 5.999-.707.707 5.293 5.293H1v1h21.086l-5.294 5.295.707.707L24 12.499l-6.5-6.5z" data-name="Right"></path>
                        </svg>
                    </div>
                </button>
                <script type="application/json">${JSON.stringify(colourGroup)}</script>
            </div>`;
        }).join("");
        const preview = `<div class="grid-item-preview" style="order: 5;"> <div class="colorGroup-preview"> <div class="preview-header"> <p class="colorGroup-title"></p> <button class="close-preview-btn close-colour__group">X</button> </div> <div class="preview-items-sec"></div> </div> </div>`
        wrapper.insertAdjacentHTML("beforeend", preview);
    }

    const addEventListeners = ({ elements, eventTypes, handler }) => {
        elements.forEach(el => {
            (Array.isArray(eventTypes) ? eventTypes : [eventTypes]).forEach(eventType => {
                el.addEventListener(eventType, handler, true);
            });
        });
    };

    const colourChartTabs = document.querySelectorAll(".colour-chart-tab");
    addEventListeners({ elements: colourChartTabs, eventTypes: "click", handler: handleColourChartTabChange });

    const colourTiles = document.querySelectorAll(".color-item");
    addEventListeners({ elements: colourTiles, eventTypes: "click", handler: handleColourTileClick });

    const colourItemIcons = document.querySelectorAll(".tab-content-wrapper");
    addEventListeners({ elements: colourItemIcons, eventTypes: ["mouseenter", "mouseleave"], handler: handleIconHover });

    const colourGroups = document.querySelectorAll(".grid-colour__group");
    addEventListeners({ elements: colourGroups, eventTypes: "click", handler: handleColourGroupClick });

    const colourProducts = document.querySelectorAll(".grid-colour__product");
    addEventListeners({ elements: colourProducts, eventTypes: "click", handler: handleColourProductClick });

    const closeButtonConfig = [
        { selector: ".close-colour__group", tabId: "colour-groups" },
        { selector: ".close-colour__product", tabId: "colour-products" }
    ];

    closeButtonConfig.forEach(({ selector, tabId }) => {
        const btn = document.querySelector(selector);
        if (btn) {
            btn.addEventListener("click", () => {
                const tabWrapper = document.querySelector(`[data-id='${tabId}']`);
                const gridPreview = tabWrapper.querySelector(".grid-item-preview");
                $(gridPreview).slideUp();
            });
        }
    });

    const tabWrappers = document.querySelectorAll("[data-id='colour-groups'], [data-id='colour-products']");
    tabWrappers.forEach((tabWrapper) => {
        const gridPreview = tabWrapper.querySelector(".grid-item-preview");

        if (!gridPreview) return;

        gridPreview.addEventListener("click", (e) => {
            const target = e.target;
            const isColourItem = target.closest(".color-item");
            const isColourVariation = target.closest(".colorProduct-variations");
            if (isColourItem || isColourVariation) {
                handleColourTileClick(e);
            }
        });
    });

    function renderIcons(product) {
        if (!product) return "";

        const extraIcons = { cpt_cs_icon: "https://cdn.shopify.com/s/files/1/0086/9587/3621/files/icon-21.png", cd_01_icon: "https://cdn.shopify.com/s/files/1/0086/9587/3621/files/icon-7.png", ten_01_icon: "https://cdn.shopify.com/s/files/1/0086/9587/3621/files/icon-20.png", pdl_01_icon: "https://cdn.shopify.com/s/files/1/0086/9587/3621/files/icon-8.png", };

        const baseImg = `<img class="item-icon" data-title="${product.name}" src="${product.icon_src}" height="" width="">`;

        const extraImg = extraIcons[product.key] ?
            `<img class="item-icon" data-title="${product.name}" src="${extraIcons[product.key]}" height="" width="">` :
            "";

        return baseImg + extraImg;
    };

    function renderColourTiles(wrapper, colourList) {
        const iconKeys = ['cc_icon', 'pdl_01_icon', 'ag_icon', 'rc_icon', 'bcr_icon', 'cpt_cs_icon', 'cpt_c_icon', 'cs_icon', 'can_icon', 'cd_01_icon', 'cd_02_icon', 'pdl_02_icon', 'cr_icon', 'cg_icon', 'juv_icon', 'ten_01_icon', 'ten_02_icon', 'ren_icon', 'tan_icon', 'sd_icon', 'tfad_icon'];
        const iconImage = { "ag_icon": "icon-3.png", "bcr_icon": "icon-18.png", "can_icon": "icon-5.png", "cc_icon": "icon-1.png", "cd_01_icon": "icon-6.png", "cd_02_icon": "icon-7.png", "cg_icon": "icon-10.png", "cpt_cs_icon": "icon-19.png", "cpt_c_icon": "icon-21.png", "cr_icon": "icon-9.png", "cs_icon": "icon-4.png", "juv_icon": "icon-11.png", "pdl_01_icon": "icon-2.png", "pdl_02_icon": "icon-8.png", "rc_icon": "icon-17.png", "ren_icon": "icon-13.png", "sd_icon": "icon-15.png", "tan_icon": "icon-14.png", "ten_01_icon": "icon-12.png", "ten_02_icon": "icon-20.png", "tfad_icon": "icon-16.png" }

        wrapper.innerHTML = colourList.map(colour => {
            const productMap = {};
            for (const key of iconKeys) {
                productMap[key] = colour.products.find(product => product.key === key);
            }

            return `
            <div class="color-item" aria-controls="colour-tile-details" style="background:${colour.hex}">
                <div class="colors-icon-options">
                    <div class="left">
                        <div class="colors-icon">${renderIcons(productMap.cc_icon)}</div>
                        <div class="colors-icon"></div>
                        <div class="colors-icon">${renderIcons(productMap.ag_icon)}</div>
                        <div class="colors-icon">${renderIcons(productMap.rc_icon)}</div>
                        <div class="colors-icon">${renderIcons(productMap.bcr_icon)}</div>
                        <div class="colors-icon v-box-2 single-img top">
                            ${renderIcons(productMap.cpt_cs_icon)}
                        </div>
                    </div>
                    <div class="center">
                        <div class="colors-icon">${renderIcons(productMap.cs_icon)}</div>
                        <div class="colors-icon">${renderIcons(productMap.can_icon)}</div>
                        <div class="colors-icon h-box-2">
                            ${renderIcons(productMap.cd_01_icon)}
                        </div>
                        <div class="colors-icon h-box-2">
                            ${renderIcons(productMap.pdl_01_icon)}
                        </div>
                        <div class="colors-icon">${renderIcons(productMap.cr_icon)}</div>
                        <div class="colors-icon">${renderIcons(productMap.cg_icon)}</div>
                        
                        <button type="button" class="colors-info">
                            <p class="color-info-text">
                                <span>${window.themeVariables.strings.colour_details}</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 50 50">
                                    <path d="M21 3C11.6 3 4 10.6 4 20s7.6 17 17 17c3.4 0 6.5-1.1 9.1-2.7l12.3 12.3 4.3-4.3-12.1-12.1C36.7 27.4 38 23.9 38 20c0-9.4-7.6-17-17-17zM21 7c7.2 0 13 5.8 13 13s-5.8 13-13 13S8 27.2 8 20 13.8 7 21 7z"/>
                                </svg>
                            </p>
                            <p class="color-available-in">
                                <span class="available-in-text">${window.themeVariables.strings.available_in}</span>
                                <span class="available-product-text"></span>
                            </p>
                        </button>
                    </div>
                    <div class="right">
                        <div class="colors-icon">${renderIcons(productMap.juv_icon)}</div>
                        <div class="colors-icon v-box-2">
                            ${renderIcons(productMap.ten_01_icon)}
                        </div>
                        <div class="colors-icon ${productMap.ren_icon ? "blue-bg" : ""}">
                            ${renderIcons(productMap.ren_icon)}
                        </div>
                        <div class="colors-icon">${renderIcons(productMap.tan_icon)}</div>
                        <div class="colors-icon">${renderIcons(productMap.sd_icon)}</div>
                        <div class="colors-icon ${productMap.tfad_icon ? "half-blue-bg" : ""}">
                            ${renderIcons(productMap.tfad_icon)}
                        </div>
                    </div>
                </div>
                <div class="color-details" style="color: ${colour.name_hex}">
                    <span class="color-number">${colour.code}</span>
                    <p class="color-text">${colour.name}</p>
                </div>
                <div class="plus-icon" style="color: ${colour.name_hex}">+</div>
                <script type="application/json">${JSON.stringify(colour)}</script>
            </div>`;
        }).join("");
    }

    function handleColourChartTabChange({ currentTarget }) {
        const target = currentTarget.getAttribute("data-tab");
        colourChartTabs.forEach(tab => tab.classList.remove("active"));
        currentTarget.classList.add("active");

        const tabContents = document.querySelectorAll(".tab-content");
        tabContents.forEach(tc => tc.classList.remove("active"));
        const targetContent = document.querySelector(`.tab-content[data-id='${target}']`);
        if (targetContent) targetContent.classList.add("active");
    }

    function handleColourTileClick({ target }) {
        const colorItemElement = target.closest(".color-item") || target.closest(".colorProduct-variations")
        const colourTileDetails = JSON.parse(colorItemElement.querySelector("script").innerText);
        const modal = document.querySelector("#colour-tile-details");
        const modalTitle = modal.querySelector("#color-tile__name");
        const modalColourCode = modal.querySelector(".colorNumber");
        const modalHeaderBg = modal.querySelector(".colorBG");
        const modalProductsContainer = modal.querySelector(".colour-tile__products");
        const excludeKeys = ["cd_02_icon", "ten_02_icon", "pdl_02_icon", "cpt_c_icon"];
        const filteredProducts = colourTileDetails.products.filter((product) => excludeKeys.indexOf(product.key) === -1);
        const productOrder = { "8949560901882": 1, "8949560803578": 2, "8949560934650": 3, "8949560967418": 4, "8949560017146": 5, "8949560869114": 6, "8949560541434": 7, "8949560574202": 8, "8949559787770": 9, "8951506567418": 10, "8951505191162": 11, "8949559623930": 12, "8949555790074": 13, "8949559722234": 14, "8949559820538": 15, "8949560836346": 16, "8949559492858": 17, "8949555429626": 18, "8949555462394": 19, "8949555495162": 20, }
        const productList = filteredProducts.map((product) => ({ order: productOrder[product.id], ...product })).sort((a, b) => a.order - b.order);
        const nameColorHex = colourTileDetails.name_hex;
        modalProductsContainer.innerHTML = productList.map(metaProduct => `
            <div class="colorProduct">
                <div class="colorProduct-img">
                    <img src="${metaProduct.featured_image}&width=600" alt="${metaProduct.name}" />
                </div>
                <div class="colorProduct-name">${metaProduct.name}</div>
                <a href="${window.Shopify.routes.root}products/${metaProduct.handle}" class="view-btn">View Product</a>
                <div class="product-icon ${metaProduct.key === 'cpt_cs_icon' ? "reverse" : ''}">
                    ${renderIcons(metaProduct)}
                </div>
            </div>
        `).join("");
        const root = document.documentElement;
        root.style.setProperty('--modal-cross-color', `${nameColorHex}`);
        modalTitle.textContent = colourTileDetails.name;
        modalColourCode.textContent = colourTileDetails.code;
        modalHeaderBg.style.background = colourTileDetails.hex;
    }

    function handleIconHover({ target, type }) {
        const isItemIcon = target.closest(".item-icon");
        if (isItemIcon) {
            const colourTile = isItemIcon.closest(".color-item");
            const productTitle = isItemIcon.getAttribute("data-title");
            const button = colourTile.querySelector(".colors-info");
            clearTimeout(window.hoverTimeout);
            let time = window.hoverTimeout ? 500 : 100;
            window.hoverTimeout = setTimeout(() => {
                button.querySelector(".available-product-text").textContent = productTitle;
                button.classList.toggle("active", type === "mouseenter");
            }, time);
        }
    }

    function findRowEndIndex(columns, currentIndex, arrayLength) {
        const row = Math.floor(currentIndex / columns);
        const endIndex = (row + 1) * columns - 1;
        return Math.min(endIndex, arrayLength - 1);
    }

    function getNearestIndex(index, array) {
        const windowWidth = window.innerWidth;
        if (windowWidth > 1080) return findRowEndIndex(5, index, array.length);
        if (windowWidth > 991) return findRowEndIndex(4, index, array.length);
        if (windowWidth > 624) return findRowEndIndex(3, index, array.length);
        if (windowWidth <= 624) return findRowEndIndex(2, index, array.length);
        return findRowEndIndex(5, index, array.length);
    }

    function handleColourGroupClick({ currentTarget }) {
        console.log({currentTarget});
        const colourGroupIndex = parseInt(currentTarget.getAttribute("data-index"));
        const tabWrapper = document.querySelector("[data-id='colour-groups']");
        const gridPreview = tabWrapper.querySelector(".grid-item-preview");
        const currentGridOrder = parseInt(gridPreview.style.order);
        const colourGroupDetails = JSON.parse(currentTarget.querySelector("script").innerText);
        const gridPreviewTitle = gridPreview.querySelector(".colorGroup-title");
        const gridPreviewItemsWrapper = gridPreview.querySelector(".preview-items-sec");
        const nearestIndex = getNearestIndex(colourGroupIndex, document.querySelectorAll(".grid-colour__group"));

        $(gridPreview).slideUp();
        setTimeout(() => {
            $(gridPreview).slideDown(500, () => scrollToDiv(gridPreview));
            console.log({colourGroupDetails});

            const sortedColourTiles = colourGroupDetails.colour_list.sort((a, b) => a.order - b.order);
            renderColourTiles(gridPreviewItemsWrapper, colourGroupDetails.colour_list);

            gridPreviewTitle.textContent = colourGroupDetails.name;
            gridPreview.style.order = nearestIndex;
        }, 500);


    }

    function scrollToDiv(selector, offset = 0, behavior = 'smooth') {
        const element = typeof selector === 'string' ? document.querySelector(selector) : selector;
        if (!element) return;
        const stickyHeaderHeight = document.querySelector(".shopify-section--header").clientHeight;
        const elementTop = element.getBoundingClientRect().top + window.pageYOffset - (offset + stickyHeaderHeight);
        window.scrollTo({ top: elementTop, behavior: behavior });
    }

    function handleColourProductClick({ currentTarget }) {
        const colourProductDetails = JSON.parse(currentTarget.querySelector("script").innerText);
        const tabWrapper = document.querySelector("[data-id='colour-products']");
        const gridPreview = tabWrapper.querySelector(".grid-item-preview");
        const currentGridOrder = parseInt(gridPreview.style.order);
        const gridPreviewTitle = gridPreview.querySelector(".colorGroup-title");
        const gridPreviewItemsWrapper = gridPreview.querySelector(".preview-items-sec");
        const colourGroupIndex = parseInt(currentTarget.getAttribute("data-index"));
        const nearestIndex = getNearestIndex(colourGroupIndex, colourProducts);
        $(gridPreview).slideUp();

        setTimeout(() => {
            $(gridPreview).slideDown(500, () => scrollToDiv(gridPreview));

            const sortedColourTiles = colourProductDetails.colour_list.sort((a, b) => a.order - b.order);
            gridPreviewItemsWrapper.innerHTML = sortedColourTiles.map(colour => `
                <button class="colorProduct-variations" aria-controls="colour-tile-details" style="background: ${colour.hex}; color: #fff;">
                    <div class="color-details" style="color: ${colour.name_hex}">
                        <span class="color-number">${colour.code}</span>
                        <p class="color-text">${colour.name}</p>
                    </div>
                    <div class="plus-icon" style="color: ${colour.name_hex}">+</div>
                    <script type="application/json">${JSON.stringify(colour)}</script>
                </button>
            `).join("");

            gridPreviewTitle.textContent = colourProductDetails.name;
            gridPreview.style.order = nearestIndex;
        }, 500);
    }
})();